import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, ErrorHandler } from "@angular/core";
import { provideRouter, Router } from "@angular/router";

import { routes } from "./app.routes";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { FeatherModule } from "angular-feather";
import { allIcons } from "angular-feather/icons";
import { TablerIconsModule } from "angular-tabler-icons";
import * as TablerIcons from "angular-tabler-icons/icons";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, provideHttpClient, withInterceptors } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { authInterceptor } from "../../../shared/src/lib/interceptors/auth.interceptor";
import { errorInterceptor } from "../../../shared/src/lib/interceptors/error.interceptor";
import { loaderInterceptor } from "../../../shared/src/lib/interceptors/loader.interceptor";
import { provideFeatureFlag } from "../../../shared/src/lib/providers/feature-flag.provider";
import { apiTimingInterceptor } from "../../../shared/src/lib/interceptors/api-timing.interceptor";
import { provideNativeDateAdapter } from "@angular/material/core";
import { provideHotToastConfig } from "@ngxpert/hot-toast";
import * as Sentry from "@sentry/angular";
import { provideMaintenance } from "../../../shared/src/lib/providers/maintenance-mode.provider";
import { GlobalLinkHandoffService } from "../../../shared/src/lib/services/global-link-handoff.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    importProvidersFrom(HttpClient),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    importProvidersFrom(TablerIconsModule.pick(TablerIcons)),
    importProvidersFrom(FeatherModule.pick(allIcons)),
    provideAnimationsAsync("noop"),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor, loaderInterceptor, apiTimingInterceptor])),
    provideNativeDateAdapter(),
    provideHotToastConfig({
      autoClose: true,
      duration: 5000,
      position: "bottom-right",
      dismissible: true,
    }),
    provideFeatureFlag(),
    provideMaintenance(),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    GlobalLinkHandoffService,
    { provide: APP_INITIALIZER, useFactory: initHandoff, deps: [GlobalLinkHandoffService], multi: true },
  ],
};

export function initHandoff(s: GlobalLinkHandoffService) {
  return () => s.init();
}

export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export interface AppSettings {
  dir: "ltr" | "rtl";
  theme: string;
  sidenavOpened: boolean;
  sidenavCollapsed: boolean;
  boxed: boolean;
  horizontal: boolean;
  activeTheme: string;
  language: string;
  cardBorder: boolean;
  navPos: "side" | "top";
}

export const defaults: AppSettings = {
  dir: "ltr",
  theme: "light",
  sidenavOpened: false,
  sidenavCollapsed: false,
  boxed: true,
  horizontal: false,
  cardBorder: false,
  activeTheme: "orange_theme",
  language: "en-us",
  navPos: "side",
};
